import React, { useState, useEffect } from 'react';

const StudentForm = ({ onSubmit, editingStudent }) => {
  const [form, setForm] = useState({ name: '', address: '', education: '' });

  useEffect(() => {
    if (editingStudent) {
      setForm({
        name: editingStudent.S_NAME,
        address: editingStudent.S_ADDRESS,
        education: editingStudent.S_EDUCATION,
      });
    }
  }, [editingStudent]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
    setForm({ name: '', address: '', education: '' });
  };

  return (
    <form onSubmit={handleSubmit} className="mb-4">
      <div className="row g-3">
        <div className="col-md-4">
          <input
            className="form-control"
            placeholder="Name"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-4">
          <input
            className="form-control"
            placeholder="Address"
            name="address"
            value={form.address}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-4">
          <input
            className="form-control"
            placeholder="Education"
            name="education"
            value={form.education}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-12 d-flex justify-content-end">
          <button type="submit" className="btn btn-success">
            {editingStudent ? 'Update' : 'Add'} Employee
          </button>
        </div>
      </div>
    </form>
  );
};

export default StudentForm;
